// extracted by mini-css-extract-plugin
export default {"container":"MapComponent_container__z0SH7","map":"MapComponent_map__JjaIP","spin":"MapComponent_spin__OzCb8","state":"MapComponent_state__89JUa","link":"MapComponent_link__3ZJ3g"};